import { Injectable } from '@angular/core';
import { ShellDomainProvider } from './shell-domain.provider';
import { EcapTranslateService } from '../translation/EcapTranslateService';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class UtilityService {
    constructor(private translateService?: TranslateService) { }
    getNewGuid() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }
    getShortGuid() {
        return Math.random().toString(36).substr(2, 10).toUpperCase();
    }
    getISODate(date) {
        date = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0)).toISOString();
        return date;
    }

    private languageList = [{ id: 'en', value: 'en-US' }, { id: 'de', value: 'de-DE' }, { id: 'cz', value: 'cs-CZ' }, { id: 'fr', value: 'fr-FR' }]

    getCurrentLanguageValue() {
        let langValue = 'en-US';
        const langKey = this.translateService.currentLang || 'en';
        const languages = ShellDomainProvider['api'].language ? ShellDomainProvider['api'].language : this.languageList;
        const selectedLang = languages.find(x => x['id'] == langKey);
        if (selectedLang)
            langValue = selectedLang['value'];

        return langValue;
    }

    getMailDiscussionTemplate(templates?: any): string {
        if (!templates) {
            const mailConfigs = ShellDomainProvider['api']['mailDiscussionConfig'];
            if (mailConfigs) {
                const template = mailConfigs.find((template: any) => template.langKey == this.translateService.currentLang);
                return template ? template.templateName : 'mail-discuss';
            }

            return 'mail-discuss';
        }

        if (Array.isArray(templates)) {
            const template = templates.find((template: any) => template.langKey == this.translateService.currentLang);
            return template ? template.templateName : 'mail-discuss';
        }

        return templates;
    }
}